import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 1,
  title: "Chlorine Vaporizes Into a Gas When Water Gets Hot (And Opens Your Toddler's Pores)",
  titleImages: [{
    url: 'https://cdn.magicpatterns.com/uploads/59cxepsRd5f7eCtWH9r6mj/Untitled_design.jpg',
    alt: 'Baby with eczema and skin irritation on torso showing the effects of chlorine exposure on toddler skin'
  }],
  mechanism: <>
      Chlorine isn't just a liquid in your tap. At room temperature, it already
      wants to escape as a gas—that's why you smell it. When water heats up
      (most parents bathe toddlers in warm to hot water for comfort), chlorine
      molecules <strong data-id="element-84">accelerate their escape rate dramatically</strong>.
    </>,
  avatars: {},
  bridge: <>
      A topical cream can soothe open pores, but it{' '}
      <strong data-id="element-85">can't prevent</strong> chlorine vapor from entering them during
      the bath.
    </>,
  imageOnLeft: false
};
export function Item1Section() {
  return <ItemSection data={data} data-id="element-86" />;
}